import React, { FC } from 'react';
import { UseTableColumnsParams } from '@v2/pages/common/components/NCFileBatchEvents/types';
import { scale as initialScale } from '@components/frame';
import TimeDisplayInStaticFormat from '@components/common/TimeDisplayInStaticFormat';
import { DURATION_COLORS } from '@v2/pages/common/components/NCFileBatchEvents/constants';
import { EventStatusSubStatusExecModeProps } from '@v2/pages/common/components/NCFileBatchEvents/components/EventStatusSubStatusExecMode';

export interface DurationCellProps
  extends Pick<UseTableColumnsParams, 'textConfig' | 'C' | 'eventType' | 'scale'>,
    Pick<EventStatusSubStatusExecModeProps, 'event'> {}

const DurationCell: FC<DurationCellProps> = ({ event, eventType, textConfig, C, scale = initialScale }) => {
  const timeValue = textConfig.duration?.[eventType]?.(event) ?? 0;
  const durationColor = DURATION_COLORS[eventType];

  return (
    <TimeDisplayInStaticFormat
      timeValue={timeValue}
      C={C}
      color={durationColor}
      fontForDigit={'Time 3'}
      fontForSecondDigit={'Time 4'}
      fontForDelimiter={'Caption 1'}
    />
  );
};

export default React.memo(DurationCell, (prev, next) => {
  return prev.event.sequenceNumber === next.event.sequenceNumber && prev.eventType === next.eventType && prev.C.scheme === next.C.scheme;
});
